module.exports = __webpack_public_path__ + "img/m10.cedd4f0.jpg";